import "./ContactComponent.css";
const ContactComponent = ({
  icon,
  title,
  desc,
  url,
  list = [],
}) => {
  return (
    <div
      onClick={() => {
        window.location.href = url;
      }}
      className="contact-container"
    >
      <span className="contact-icon">
        <img
          className="about__card-icon"
          width={30}
          src={icon}
          alt=""
        />
      </span>
      <h5>{title}</h5>
      <small>{desc}</small>
      <div className="contact-list">
        {list.map((sub) => (
          <div className="contact-list-item">{sub}</div>
        ))}
      </div>
    </div>
  );
};

export default ContactComponent;
